import React, { useEffect, useState } from "react";
import { Modal, Button, Carousel, Avatar } from "antd";
import { CloseCircleOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { CustomNextArrow, CustomPrevArrow } from "../Icon/arrowCrousel";
import { lang } from "../../constants/common.const";
import { VideoApi } from "../../api/backend/video";
import { convertGoogleDriveLinkToEmbed } from "../../utils/helper";
import { handleCatchError } from "../../constants/utils";
import Text from "antd/lib/typography/Text";
import moment from "moment";
import { linkifyText } from "../../page/VideoManagement/videoDescription";
import { isMobile } from "react-device-detect";
import { ShowMoreText } from "../Text/showMoreText";

const VideoModal = ({ id, fontSize = 14, color = "#0080cb", isMachine }) => {
  const [listVideo, setListVideo] = useState([]);
  const [isShowModal, setIsShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(1);

  const handleFetchVideoCheckItem = async (id) => {
    try {
      setIsShowModal(true);
      const res = await VideoApi.getVideoByIdCheck(id);
      const data = res.data.data.map((i) => ({
        ...i,
        url: convertGoogleDriveLinkToEmbed(i.videoUrl),
        videoId: i.id,
      }));
      setListVideo(data);
      if (data.length > 0) {
        handleChangeVideo(0, data[0]);
      }
    } catch (error) {
      handleCatchError(error);
    }
  };
  const handleFetchVideoMachine = async (id) => {
    try {
      setIsShowModal(true);
      const res = await VideoApi.getVideoByMachine(id);
      const data = res.data.data.map((i) => ({
        ...i,
        url: convertGoogleDriveLinkToEmbed(i.videoUrl),
        videoId: i.id,
      }));
      setListVideo(data);
      if (data.length > 0) {
        handleChangeVideo(0, data[0]);
      }
    } catch (error) {
      handleCatchError(error);
    }
  };
  const onClose = () => {
    setIsShowModal(false);
  };

  const handleChangeVideo = (current, initData) => {
    try {
      if (!Number.isInteger(current)) {
        return;
      }
      setCurrentIndex(current + 1);
      if (initData) {
        VideoApi.addCountView(initData.videoId);
      } else if (listVideo.length > 0) {
        const currentVideo = listVideo[current];
        VideoApi.addCountView(currentVideo.videoId);
      }
    } catch (error) {}
  };
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <VideoCameraOutlined
        style={{
          fontSize,
          color,
        }}
        onClick={() => {
          setIsShowModal(true);
          if (isMachine) {
            handleFetchVideoMachine(id);
          } else {
            handleFetchVideoCheckItem(id);
          }
        }}
      />
      {isShowModal && (
        <Modal
          title={"動画一覧"}
          width={1200}
          visible={isShowModal}
          onCancel={onClose}
          closable={false}
          centered
          footer={[
            <Button
              key="close"
              className="buttonPC --todo-- wAuto button--outline"
              onClick={onClose}
            >
              <CloseCircleOutlined />
              {lang.CLOSE}
            </Button>,
          ]}
          bodyStyle={{
            maxHeight: "85vh",
            overflowY: "auto",
          }}
        >
          <div style={{ paddingInline: 20 }}>
            <Carousel
              afterChange={handleChangeVideo}
              prevArrow={currentIndex != 1 ? <CustomPrevArrow /> : <></>}
              nextArrow={
                currentIndex != listVideo.length ? <CustomNextArrow /> : <></>
              }
              arrows
              infinite={false}
            >
              {listVideo.map((video, index) => (
                <div>
                  <div
                    style={{
                      fontSize: 17,
                      marginBottom: 10,
                    }}
                    className="center bold"
                  >
                    動画 : {currentIndex} / {listVideo.length}
                  </div>
                 <div >
                 <iframe
                    style={{
                      borderRadius: 10,
                    }}
                    key={index}
                    width="100%"
                    height={isMobile ? 300 : 480}
                    src={video.url}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    title={`video-${index}`}
                  ></iframe>
                 </div>
                  <h2
                    onClick={() =>
                      window.open(`/VideoManagement/View/${video.videoId}?from=checklist`, "")
                    }
                    className="bold title-video-machine-popup"
                  >
                    {video.title}{" "}
                  </h2>

                  <div className="video-wrap-author mb10">
                    <div className="video-author">
                      <Avatar
                        src={video.avatarUrl}
                        size={"large"}
                        className="video-comment-avatar"
                      >
                        {video.displayName
                          ? video.displayName.charAt(0).toUpperCase()
                          : ""}
                      </Avatar>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          className="video-comment-header"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <Text className="video-comment-author" strong>
                            {video.displayName}
                          </Text>
                        </div>
                        <div style={{ fontSize: 12, color: "gray" }}>
                          {video.updateDatetime
                            ? moment(video.updateDatetime).format(
                                "YYYY/MM/DD HH:mm:ss"
                              )
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <ShowMoreText text={linkifyText(video.videoExplanation)}  lineNumber={2}/>
                    </div>
                </div>
              ))}
            </Carousel>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default VideoModal;
